import { type Maybe } from '@gql/schema';
import { IconName, isIconName } from '@secretescapes/falcon';
import { capitalize } from '@utils/lodash.utils';

export const transformIconName = (categoryId: Maybe<string>) => {
  if (!categoryId) {
    return IconName.highlightFallback;
  }

  const iconNameKey = `highlight${capitalize(categoryId)}`;

  return isIconName(iconNameKey) ? IconName[iconNameKey] : IconName.highlightFallback;
};
